import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { type Observable } from 'rxjs';
import type { CourtFeatures, Feature, PleaOptions } from '../../types';

type ConfigRes = {
  courtId: string;
  pleaOptions: PleaOptions;
  features: Array<Feature>;
};

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly http = inject(HttpClient);

  load(lang?: string): Observable<ConfigRes> {
    /**
     * Should remain as let because this class is immutable.
     * Details: {@link https://angular.dev/api/common/http/HttpParams#description}
     */
    let params = new HttpParams();
    if (lang) {
      params = params.set('lang', lang);
    }
    return this.http.get<ConfigRes>(`api/v1/tickets/workup/current/court/config`, { params });
  }

  getCourtFeatures(): Observable<CourtFeatures> {
    return this.http.get<CourtFeatures>(`api/v1/tickets/workup/current/court-features`);
  }
}
